import {Layout, Radio, RadioGroup} from '@ui-kitten/components';
import React, {useEffect, useState} from 'react';
import {StyleSheet} from 'react-native';
import {px, safeText} from '../../utils';
import TitleRow from './TitleRow';

const RadioList = ({title, list, setSelectedItem, containerStyle}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isListVisible, setIsListVisible] = useState(true);

  useEffect(() => {
    const selectedValue = list?.find((_, index) => selectedIndex === index);
    if (selectedValue !== undefined) {
      setSelectedItem(selectedValue);
    }
  }, [list, selectedIndex, setSelectedItem]);
  return (
    <Layout style={containerStyle}>
      <TitleRow
        title={title}
        type="secondary"
        iconName={
          isListVisible
            ? 'arrow-ios-upward-outline'
            : 'arrow-ios-downward-outline'
        }
        onIconClick={() => setIsListVisible(!isListVisible)}
        containerStyle={styles.title}
      />
      {list?.length > 0 && isListVisible && (
        <Layout level="1">
          <RadioGroup
            style={styles.row}
            selectedIndex={selectedIndex}
            onChange={setSelectedIndex}>
            {list.map(({text, value}) => (
              <Radio key={value}>{safeText(text)}</Radio>
            ))}
          </RadioGroup>
        </Layout>
      )}
    </Layout>
  );
};

const styles = StyleSheet.create({
  row: {
    marginHorizontal: px(17),
  },
});

export default RadioList;
